import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import {apiValidateSharedPWD} from '../../../redux/api'
import {useParams} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const ShareLinkForm = ({setVerifyStatus, setData}: any) => {
  const {id} = useParams()
  const intl = useIntl()

  const initialValues = {
    password: '',
  }

  const verifyPasswordSchema = Yup.object().shape({
    password: Yup.string().required(
      intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED'}, {name: 'Password'})
    ),
  })
  const [loading, setLoading] = useState<boolean>(false)
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [capsLockOn, setCapsLockOn] = useState<boolean>(false)

  const formik = useFormik({
    initialValues,
    validationSchema: verifyPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)

      const data: any = {
        key: id,
        password: values.password,
      }
      apiValidateSharedPWD(data)
        .then(({data}) => {
          if (data.status === 200) {
            setLoading(false)
            setVerifyStatus(true)
            setData(data.response)
          } else {
            toast.error(
              `${intl.formatMessage({id: 'TOAST.ERROR_OCCURRED_WHILE_ACCESS_VIDEO'})} : ${data.message}`
            )
            setLoading(false)
            setSubmitting(false)
            setVerifyStatus(false)
          }
        })
        .catch((error) => {
          setVerifyStatus(false)
          setLoading(false)
          setSubmitting(false)
          toast.error(
            `${intl.formatMessage({id: 'TOAST.ERROR_OCCURRED_WHILE_ACCESS_VIDEO'})} : ${error}`
          )
        })
    },
  })

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev)
  }

  const checkCapslockStatus = (event: any) => {
    setCapsLockOn(event.getModifierState('CapsLock'))
  }
  return (
    <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom auth-bg position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        {/* <a href='#' className='mb-12'> */}
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/iFleetcam_logo.png')}
            className='h-100px img-fluid mb-12'
          />
        {/* </a> */}
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
          <form
            className='form w-100'
            onSubmit={formik.handleSubmit}
            noValidate
            id='verify_password'
          >
            {/* begin::Heading */}
            <div className='text-center mb-10'>
              <h1 className='text-dark mb-3'>
                {intl.formatMessage({id: 'GENERAL.LABEL.ENTER_PASSWORD_TO_ACCESS_VIDEO'})}
              </h1>
            </div>
            {/* begin::Heading */}

            {/* begin::Form group */}
            <div className='fv-row mb-10'>
              <div className='d-flex justify-content-between mt-n5'>
                <div className='d-flex flex-stack mb-2'>
                  {/* begin::Label */}
                  <label className='form-label fw-bolder text-dark fs-6 mb-0'>
                    {intl.formatMessage({id: 'AUTH.INPUT.PASSWORD'})}
                  </label>
                </div>
              </div>
              <div className='d-flex flex-column gap-2'>
                <div className='position-relative'>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    autoComplete='off'
                    placeholder='Enter password'
                    {...formik.getFieldProps('password')}
                    className={clsx('form-control form-control-lg form-control-solid')}
                    onKeyDown={checkCapslockStatus}
                  />
                  <button
                    type='button'
                    className='btn btn-link position-absolute top-50 end-0 translate-middle-y me-3'
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? (
                      <i className='text-dark fs-4 fa fa-eye-slash'></i>
                    ) : (
                      <i className='text-dark fs-4 fa fa-eye'></i>
                    )}
                  </button>
                </div>
                <div className='d-flex flex-column'>
                  {formik.touched.password && formik.errors.password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span
                          className='text text-danger d-flex align-items-center gap-2'
                          role='alert'
                        >
                          {formik.errors.password}
                        </span>
                      </div>
                    </div>
                  )}
                  {capsLockOn && (
                    <div className='d-flex align-items-center gap-2 text-muted'>
                      {intl.formatMessage({id: 'WARNING.ACTIVE_CAPS'})}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* end::Form group */}

            {/* begin::Action */}
            <div className='text-center'>
              <button
                type='submit'
                id='kt_sign_in_submit'
                className='btn btn-lg btn-primary w-100 mb-5'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                {!loading && (
                  <span className='indicator-label'>
                    {intl.formatMessage({id: 'GENERAL.LABEL.CONFIRM_TO_VIDEO_BUTTON'})}
                  </span>
                )}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'AUTH.GENERAL.PLEASE_WAIT'})}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            {/* end::Action */}
          </form>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-10'>
        {/* <div className='bottom-logo'> */}
        <div>
          <img
            alt='PointGuard'
            className='img-fluid'
            src={toAbsoluteUrl('/media/logos/pointguard.png')}
          />
        </div>
      </div>
      {/* end::Footer */}
    </div>
  )
}

export default ShareLinkForm
